import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import Profile from "../../../Assets/AppComponent/Profile/profile2.png";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import {
  SetAttendancePermissionResponse,
  SetTheAttendanceDatasActions,
  SetTheAttendancePermissionDatasActions,
} from "../../../Redux/Slice";
import { Link } from "react-router-dom";
const TeamManagement = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const EnglishData = data;
  const HindiData = hindiDatas;
  const [EmployeeName, setEmployeeName] = useState();
  const [empRole, setEmpRole] = useState();
  const UserData = useSelector(
    (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data
  );
  const leaveData = useSelector(
    (state) => state?.AttenDanceCall?.AttenDanceData?.data
  );
  const permissionData = useSelector(
    (state) => state?.AttenDancePermissionCall?.AttenDancePermissionData?.data
  );
  const state = useSelector((state) => state);
  const [leaveState, setLeaveStatus] = useState({
    pending_leave: "",
    total_leave: "",
    leave_valid_until: "",
  });
  const [permissionState, setPermissionStatus] = useState({
    pending_permission: "",
    total_permission: "",
    leave_permission_until: "",
  });
  useEffect(() => {
    if (UserData != undefined && UserData != null && UserData.data != undefined && UserData.data) {
      if (
        UserData.data != undefined &&
        UserData.data != null &&
        UserData.data.first_name != undefined &&
        UserData.data.first_name != null
      ) {
        setEmployeeName(UserData.data.first_name.toUpperCase());
        setEmpRole(UserData.data.user_role.role);
      }
    }
  }, [UserData]);
  ///-------------------Avaiable--_Leave----
  useEffect(() => {
    if (
      state.AttenDanceCall.AttenDanceData != null &&
      state.AttenDanceCall.AttenDanceData != undefined &&
      state.AttenDanceCall.AttenDanceData.data != undefined
    ) {
      setLeaveStatus({
        ...leaveState,
        pending_leave: Number(
          state.AttenDanceCall.AttenDanceData.data.pending_leave
        ),
        leave_valid_until:
          state.AttenDanceCall.AttenDanceData.data.leave_valid_until,
        total_leave: Number(
          state.AttenDanceCall.AttenDanceData.data.total_leave
        ),
      });
    }
  }, [state.AttenDanceCall.AttenDanceData]);

  useEffect(() => {
    if (leaveData !== undefined) {
      setLeaveStatus((prev) => ({
        ...prev,
        pending_leave: leaveData.casual_leave_pending,
        total_leave: leaveData.casual_leave,
        leave_valid_until: leaveData.permission_valid_until,
      }));
    }
  }, [leaveData]);
  useEffect(() => {
    if (permissionData !== undefined) {
      setPermissionStatus((prev) => ({
        ...prev,
        pending_permission: permissionData.pending_permissions,
        total_permission: permissionData.total_permissions,
        leave_permission_until: permissionData.permissions_valid_until,
      }));
    }
  }, [permissionData]);

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div className="OuterEmployee-Details">
          <div className="EmployeeDetails row">
          <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div
                    className="row "
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div
                      className="col-sm-3 col-md-3 col-lg-1 d-flex justify-content-start ProfileImages"
                      style={{ minWidth: "117px", maxWidth: "114px" }}
                    >
                      <img src={state.SideBarFiles.UDSEmployeeeImage != null ?
                        state.SideBarFiles.UDSEmployeeeImage : Profile} width={"90px"} height={"90px"}

                      />
                    </div>
                    <div className="col-md-9 col-sm-12 col-lg-9 text-left">
                   
                      <h3 className="m-0 mt-2">
                        {EmployeeName}&nbsp; 

                      </h3>
                      <p style={{ fontWeight: 600, fontSize: "14px", marginLeft: "2px" }}>
                        {empRole}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row BitCards" style={{ padding: "38px  34px" }}>
          <div className="col-12">
            {state.laguagefoetheemployees.COuntsForLanguage == 1 ? (
              <>
                {EnglishData.Home.CardsDatateam.BITCardsTeamEmp.map((item) => (
                  <div className="card bitCards">
                    <Link to={item.url}>
                      <div className="card-body">
                        <div className="InnerImage InnerImageAttendance">
                          <div className="IMAGE">
                            <img src={item.image} />
                          </div>
                        </div>
                        <div className=" CardContent CardContentTeamSet">
                          <div className=" Head">
                            <h4>{item.head}</h4>
                          </div>
                          <div
                            className=" ARROWIMAGE"
                            style={{ textAlign: "right" }}
                          >
                            <img src={item.arrow} />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </>
            ) : (
              <div className="card">
                <div className="card-body"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamManagement;
